module.exports = __webpack_public_path__ + "img/school-icon.580c99a2.svg";